import { Attachment } from "./attachment";
import { ICAreaMeta } from "./icareameta";
import { ICAreaRelation } from "./icarearelation";
import { ICAreaType } from "./icareatype";
import { ICMetaDescriptionArea } from "./icmetadescriptionarea";
import { ICMonitor } from "./icmonitor";
import { ICNuc } from "./icnuc";
import { ICObjective } from "./icobjective";
import { ICSchedulation } from "./icschedulation";
import { ICTime } from "./ictime";
import { ICTranslation } from "./ictranslation";
import { ICTypeArea } from "./ictypearea";
import { ICUserArea } from "./icuserarea";
import { Translation } from "./translation";

export class ICArea {
  AreaType: ICAreaType;
  Childrens: ICAreaRelation[];
  Code: string;
  DefaultContent: Attachment;
  DeleteDate: string;
  Enabled: boolean;
  Fathers: ICAreaRelation[];
  Id: number;
  IdGuid: string;
  InsertDate: string;
  LastEditDate: string;
  MetaDescriptionAreas: ICMetaDescriptionArea[];
  Metas: ICAreaMeta[];
  Monitors: ICMonitor[];
  Name: Translation[];
  Nuc: ICNuc[];
  Objectives: ICObjective[];
  Order: number;
  Primary: boolean;
  Schedulations: ICSchedulation[];
  Times: ICTime[];
  Translations: ICTranslation[];
  TypeAreas: ICTypeArea[];
  UserAreas: ICUserArea[];

  constructor(data?: Partial<ICArea>) {
    Object.assign(this, data);
  }
}
